"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MACRO_TOKEN_TO_FORMAT_OPTS = exports.TWO_DIGIT = exports.LONG = exports.SHORT = exports.NUMERIC = void 0;
const format_types_1 = require("../types/format.types");
exports.NUMERIC = 'numeric', exports.SHORT = 'short', exports.LONG = 'long', exports.TWO_DIGIT = '2-digit';
const DATE_SHORT = {
    day: exports.TWO_DIGIT,
    month: exports.TWO_DIGIT,
    year: exports.NUMERIC,
};
const DATE_MED = {
    day: exports.TWO_DIGIT,
    month: exports.SHORT,
    year: exports.NUMERIC,
};
const DATE_FULL = {
    day: exports.TWO_DIGIT,
    month: exports.LONG,
    year: exports.NUMERIC,
};
const DATE_HUGE = {
    day: exports.TWO_DIGIT,
    month: exports.LONG,
    weekday: exports.LONG,
    year: exports.NUMERIC,
};
const TIME_SIMPLE = {
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
};
const TIME_WITH_SECONDS = {
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
};
const TIME_WITH_SHORT_OFFSET = {
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
    timeZoneName: exports.SHORT,
};
const TIME_WITH_LONG_OFFSET = {
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
    timeZoneName: exports.LONG,
};
const TIME_24_SIMPLE = {
    hour: exports.TWO_DIGIT,
    hourCycle: 'h23',
    minute: exports.TWO_DIGIT,
};
const TIME_24_WITH_SECONDS = {
    hour: exports.TWO_DIGIT,
    hourCycle: 'h23',
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
};
const TIME_24_WITH_SHORT_OFFSET = {
    hour: exports.TWO_DIGIT,
    hourCycle: 'h23',
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
    timeZoneName: exports.SHORT,
};
const TIME_24_WITH_LONG_OFFSET = {
    hour: exports.TWO_DIGIT,
    hourCycle: 'h23',
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
    timeZoneName: exports.LONG,
};
const DATETIME_SHORT = {
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    month: exports.NUMERIC,
    year: exports.NUMERIC,
};
const DATETIME_SHORT_WITH_SECONDS = {
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    month: exports.NUMERIC,
    second: exports.TWO_DIGIT,
    year: exports.NUMERIC,
};
const DATETIME_MED = {
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    month: exports.SHORT,
    year: exports.NUMERIC,
};
const DATETIME_MED_WITH_SECONDS = {
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    month: exports.SHORT,
    second: exports.TWO_DIGIT,
    year: exports.NUMERIC,
};
const DATETIME_FULL = {
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    month: exports.LONG,
    timeZoneName: exports.SHORT,
    year: exports.NUMERIC,
};
const DATETIME_FULL_WITH_SECONDS = {
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    month: exports.LONG,
    second: exports.TWO_DIGIT,
    timeZoneName: exports.SHORT,
    year: exports.NUMERIC,
};
const DATETIME_HUGE = {
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    month: exports.LONG,
    timeZoneName: exports.LONG,
    weekday: exports.LONG,
    year: exports.NUMERIC,
};
const DATETIME_HUGE_WITH_SECONDS = {
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    month: exports.LONG,
    second: exports.TWO_DIGIT,
    timeZoneName: exports.LONG,
    weekday: exports.LONG,
    year: exports.NUMERIC,
};
exports.MACRO_TOKEN_TO_FORMAT_OPTS = {
    [format_types_1.FORMAT_DATE.d]: DATE_SHORT,
    [format_types_1.FORMAT_DATE.dd]: DATE_MED,
    [format_types_1.FORMAT_DATE.ddd]: DATE_FULL,
    [format_types_1.FORMAT_DATE.dddd]: DATE_HUGE,
    [format_types_1.FORMAT_DATE.f]: DATETIME_SHORT,
    [format_types_1.FORMAT_DATE.F]: DATETIME_SHORT_WITH_SECONDS,
    [format_types_1.FORMAT_DATE.ff]: DATETIME_MED,
    [format_types_1.FORMAT_DATE.FF]: DATETIME_MED_WITH_SECONDS,
    [format_types_1.FORMAT_DATE.fff]: DATETIME_FULL,
    [format_types_1.FORMAT_DATE.FFF]: DATETIME_FULL_WITH_SECONDS,
    [format_types_1.FORMAT_DATE.ffff]: DATETIME_HUGE,
    [format_types_1.FORMAT_DATE.FFFF]: DATETIME_HUGE_WITH_SECONDS,
    [format_types_1.FORMAT_DATE.t]: TIME_SIMPLE,
    [format_types_1.FORMAT_DATE.T]: TIME_24_SIMPLE,
    [format_types_1.FORMAT_DATE.tt]: TIME_WITH_SECONDS,
    [format_types_1.FORMAT_DATE.TT]: TIME_24_WITH_SECONDS,
    [format_types_1.FORMAT_DATE.ttt]: TIME_WITH_SHORT_OFFSET,
    [format_types_1.FORMAT_DATE.TTT]: TIME_24_WITH_SHORT_OFFSET,
    [format_types_1.FORMAT_DATE.tttt]: TIME_WITH_LONG_OFFSET,
    [format_types_1.FORMAT_DATE.TTTT]: TIME_24_WITH_LONG_OFFSET,
};
//# sourceMappingURL=format.constant.js.map